import { FC, HTMLAttributes } from 'react';
import 'twin.macro';
import 'styled-components/macro';

export interface IconProps extends HTMLAttributes<HTMLElement> {
  name: string;
}

export const Icon: FC<IconProps> = ({ name, className, ...props }) => (
  <i tw="font-normal" className={`icon icon-${name} ${className}`} {...props} />
);
